import type { AuthService } from './auth.service';

// Hashbrown middleware вызывается вне Angular injection context (просто из fetch wrapper),
// поэтому держим ссылку на синглтон AuthService модульной переменной.
// app.config.ts инициализирует её в provideAppInitializer.
let authRef: AuthService | null = null;

export function setAssistantAuthService(auth: AuthService): void {
  authRef = auth;
}

export function getAssistantAccessToken(): string | null {
  return authRef?.getAccessToken() ?? null;
}

/** Текущий workspace из localStorage. Тот же источник что у credentials.interceptor
 * (`x-space-id` для REST) — чтобы MCP/LLM-прокси работали в том же space. */
export function getAssistantSpaceId(): string | null {
  try {
    const raw = localStorage.getItem('selected_space');
    if (!raw) return null;
    return JSON.parse(raw)?.id ?? null;
  } catch {
    return null;
  }
}
